<h1 class="_primary cell auto" [hidden]="!displayTitle">{{title}}</h1>

<kiwi-animator-select-team class="cell shrink" *ngIf="!hideSelects"></kiwi-animator-select-team>

<kiwi-simulated-periods-selector class="cell shrink" *ngIf="!hideSelects"></kiwi-simulated-periods-selector>

<button class="button _iconLeft" [routerLink]="'/session/decisions/studies/' + category" *ngIf="!hideCloseButton" [captureId]="'navigate-backwards'">
    <i class="fas fa-angle-left"></i><span [i18nKey]="'studies.back.to.studies'"></span></button>
